<template>
  <AnimatedBackground>
    <WorkshopsSection />
  </AnimatedBackground>
</template>

<script>
import WorkshopsSection from '../components/WorkshopsSection.vue';
import AnimatedBackground from '../components/AnimatedBackground.vue';

export default {
  name: 'WorkshopsPage',
  components: {
    WorkshopsSection,
    AnimatedBackground
  }
}
</script>

<style scoped>
.workshops-page {
  min-height: 100vh;
  width: 100%;
  padding: 4rem 0;
  display: flex;
  flex-direction: column;
}
</style>
